<template>
  <div class="SubscriptionReturnPage">
    <header-banner/>

    <div class="container">
      <router-link to="/my-account" class="BackToAccountView">
        ‹ {{ $t('common.breadcrumbNav.accountOverview', 'Account overview') }}
      </router-link>
      <Subscription-return-step-nav
        :steps="steps"
        :active-step-index="activeStepIndex"
      />

      <div class="SubscriptionReturn_panel">
        <router-view
          :key="$route.fullPath"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderBanner from 'components/HeaderBanner'
  import SubscriptionReturnStepNav from 'components/SubscriptionReturnStepNav'

  export default {
    name: 'subscription-return',

    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.updatePageName('my_subscriptions_overview')
        if (vm.$route.name === 'subscription-return') {
          vm.$router.replace({ name: 'return-address' })
        }
      })
    },

    data () {
      return {
        steps: [
          { value: 'Address', name: this.$t('subscription_return.step.nav.address', 'Address'), route: { name: 'return-address' } },
          { value: 'Carriers', name: this.$t('subscription_return.step.nav.carriers', 'Carriers'), cancellable: true, route: { name: 'return-carriers' } },
          { value: 'Confirmation', name: this.$t('subscription_return.step.nav.confirmation', 'Confirmation'), cancellable: true, route: { name: 'return-confirmation' }, navigable: false }
        ],
        activeStep: ''
      }
    },

    computed: {
      activeStepIndex () {
        return this.steps.map(s => s.value).indexOf(this.activeStep)
      }
    },

    components: {
      HeaderBanner,
      SubscriptionReturnStepNav
    },

    watch: {
      '$route': function () {
        this.updateActiveStep()
      }
    },

    methods: {
      updateActiveStep () {
        const step = this.steps.find(s => s.route.name === this.$route.name)
        this.activeStep = step && step.value
      }
    },

    created () {
      this.updateActiveStep()
    }
  }
</script>

<style lang="scss">
  .SubscriptionReturn_panel {
    padding: .3rem 0 .4rem;

    .title {
      font-size: .24rem;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: .2rem;
    }

    .text-block {
      .description {
        font-size: .17rem;
        line-height: .25rem;
        font-weight: 400;
        margin-bottom: .25rem;
      }
    }
  }
</style>
